import { gql } from '@apollo/client'

export const PDS_LOOKUP = gql`
  mutation AP_LookupDemographics($patientId: ID!) {
    lookupDemographics(patientId: $patientId) {
      status
    }
  }
`
